export class SubscriptionDomain {
  static MONTHLY: string = "monthly";
  static YEARLY: string = "yearly";

  static started = 'STARTED';
  static registered = 'REGISTERED';
  static payed = 'PAYED';
  static canceled = 'CANCELED';
  static failed = 'FAILED';

  static getPaymentMethod(_countryCode: string) {
    //return countryCode === 'CL' ? 'REVENIU' : 'UNKNOWN';
    return 'REVENIU';
  }
}